import { createSelector } from 'reselect';
import { checkIsShowAlways } from 'web-interactives-data/utils/targetingUtils';
import { getIsScheduled, getIsPublished } from 'web-interactives-dashboard-ui/utils/webInteractiveStateUtils';
export const getShortInteractiveData = state => state.interactiveDetails.short;
export const getFullInteractiveData = state => state.interactiveDetails.full;
export const getInteractiveDisplayData = createSelector([getFullInteractiveData], interactive => {
  if (!interactive) {
    return null;
  }
  const state = interactive.currentState;
  const isScheduled = getIsScheduled(state);
  const isPublished = getIsPublished(state);
  const isShowAlways = interactive.triggers ? checkIsShowAlways({
    containerType: interactive.containerType,
    triggers: interactive.triggers,
    showCloseButton: interactive.interactiveStyles.showCloseButton
  }) : false;
  return {
    id: interactive.id,
    name: interactive.name,
    screenshotUrl: interactive.screenshotPreviewUrl,
    status: state,
    containerType: interactive.containerType,
    createdAt: interactive.created,
    updatedAt: interactive.updated || interactive.created,
    lastPublishedAt: interactive.publishedAt || undefined,
    unpublishedAt: !isPublished && interactive.unpublishedAt || undefined,
    scheduledFor: isScheduled && interactive.publishDate || undefined,
    unpublishScheduledFor: isPublished && interactive.pageExpiryEnabled && interactive.pageExpiryDate || undefined,
    archivedAt: interactive.archived && interactive.archivedAt || undefined,
    campaignId: interactive.campaign || undefined,
    audience: interactive.audience || undefined,
    triggers: interactive.triggers || undefined,
    isShowAlways,
    isActiveAbTest: interactive.isActiveAbTest,
    isPersonalized: !!interactive.personalizationStrategyId
  };
});